document.addEventListener('change',function(event){
const select=event.target.closest('[data-variant-select]');
if(select){const form=select.closest('form');const section=form.closest('.native-product')||form;const option=select.selectedOptions[0];const button=form.querySelector('[data-add-button]');if(option&&button){const price=section.querySelector('[data-product-price]');if(price)price.textContent=option.dataset.price;const available=option.dataset.available==='true';button.disabled=!available;const label=available?button.dataset.addLabel:button.dataset.soldLabel;const labels=button.querySelectorAll('.pani-roll>span');if(labels.length)labels.forEach(span=>span.textContent=label);else button.textContent=label;if(form.hasAttribute('data-product-form')){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}}}
if(event.target.matches('[data-sort-select]'))event.target.form.requestSubmit();
});
document.addEventListener('click',function(event){const button=event.target.closest('[data-find-button]');if(!button)return;const root=button.closest('[data-capacity-finder]');const input=root.querySelector('[data-capacity-input]');const output=root.querySelector('[data-finder-output]');const capacity=input.valueAsNumber;output.replaceChildren();if(!Number.isFinite(capacity)||capacity<1||capacity>500){output.textContent=output.dataset.invalid;input.setAttribute('aria-invalid','true');input.focus();return;}input.removeAttribute('aria-invalid');const items=[...root.querySelectorAll('[data-finder-items] a')].filter(a=>a.dataset.matchAvailable==='true'&&capacity>=Number(a.dataset.matchMin)&&capacity<=Number(a.dataset.matchMax));if(!items.length){output.textContent=output.dataset.none;return;}for(const item of items){output.append(item.cloneNode(true));}});
document.addEventListener('click',function(event){const link=event.target.closest('.header-mobile-details .mobile-nav a');if(link)link.closest('details').open=false;});

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.sf-shop-menu[open], .header-mobile-details[open]')) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
document.addEventListener('click', function(event) {
  for (const menu of document.querySelectorAll('.sf-shop-menu[open]')) {
    if (!menu.contains(event.target)) menu.open = false;
  }
});

document.addEventListener('click', event => {
  const thumb = event.target.closest('[data-gallery-image]');
  if (thumb) {
    const gallery = thumb.closest('.native-product-gallery');
    const image = gallery.querySelector('[data-gallery-main]');
    image.srcset = thumb.dataset.srcset;
    image.src = thumb.dataset.src;
    image.alt = thumb.dataset.alt;
    gallery.querySelectorAll('[data-gallery-image]').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
  }
  for (const menu of document.querySelectorAll('.sf-shop-menu[open], .header-mobile-details[open]')) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  }
});
document.addEventListener('focusin', event => {
  for (const menu of document.querySelectorAll('.sf-shop-menu[open], .header-mobile-details[open]')) {
    if (!menu.contains(event.target)) menu.open = false;
  }
});
window.matchMedia('(max-width: 760px)').addEventListener('change', () => {
  document.querySelectorAll('.sf-shop-menu[open], .header-mobile-details[open]').forEach(menu => { menu.open = false; });
});
